import {
  LOAD_ACCESS_LEVELS_PENDING,
  LOAD_ACCESS_LEVELS_FULFILLED,
  LOAD_ACCESS_LEVELS_REJECTED,
  LOAD_LANGUAGES_PENDING,
  LOAD_LANGUAGES_FULFILLED,
  LOAD_LANGUAGES_REJECTED,
  LOAD_REGIONS_PENDING,
  LOAD_REGIONS_FULFILLED,
  LOAD_REGIONS_REJECTED,
  LOAD_MODELS_PENDING,
  LOAD_MODELS_FULFILLED,
  LOAD_MODELS_REJECTED,
  LOAD_ACCOUNT_TYPES_PENDING,
  LOAD_ACCOUNT_TYPES_FULFILLED,
  LOAD_ACCOUNT_TYPES_REJECTED,
  CLEAR_SHARED_MESSAGES,
} from '../actions/shared'
import i18n from 'i18next'

export default function shared(state = {}, action) {
  switch (action.type) {
    case LOAD_ACCESS_LEVELS_PENDING:
    case LOAD_LANGUAGES_PENDING:
    case LOAD_REGIONS_PENDING:
    case LOAD_MODELS_PENDING:
    case LOAD_ACCOUNT_TYPES_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      }
    case LOAD_ACCESS_LEVELS_REJECTED:
    case LOAD_LANGUAGES_REJECTED:
    case LOAD_REGIONS_REJECTED:
    case LOAD_MODELS_REJECTED:
    case LOAD_ACCOUNT_TYPES_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }

    case LOAD_ACCESS_LEVELS_FULFILLED:
      return {
        ...state,
        accessLevels: action.payload.accessLevels,
        isLoading: false,
      }

    case LOAD_LANGUAGES_FULFILLED:
      return {
        ...state,
        languages: action.payload,
        isLoading: false,
      }

    case LOAD_REGIONS_FULFILLED:
      return {
        ...state,
        regions: action.payload.regions,
        isLoading: false,
      }
    case LOAD_MODELS_FULFILLED:
      return {
        ...state,
        models: action.payload.data,
        isLoading: false,
      }
    case LOAD_ACCOUNT_TYPES_FULFILLED:
      return {
        ...state,
        accountTypes: action.payload.data,
        isLoading: false,
      }
    case CLEAR_SHARED_MESSAGES: {
      return {
        ...state,
        errorMessage: null,
      }
    }
    default:
      return state
  }
}
